import type { DialogConfig } from '#types/config/components/dialog'
import type { RecursivePartial } from '#types/utils'

export default {
  brandClasses: {
    findInStoreForm: 'space-y-4'
  },
  cancelButtonVariant: 'secondary',
  dialogOptions: {
    type: {
      sm: 'panel',
      md: 'modal'
    }
  },
  myLocationButtonVariant: 'secondary',
  storesLayout: 'pickup'
} satisfies RecursivePartial<DialogConfig['pickupInStore']>
